import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Button from 'components/Button'
import GoogleMap from 'components/GoogleMap'
import Layout from 'components/Layout'
import Link from 'components/Link'
import Text from 'components/Text'
import urls from 'constants/urls'
import styles from './Home.module.scss'
import logoImage from './images/logo.svg'

export default function Home() {
  return (
    <Layout className={classNames('Home', styles.this)}>
      <div className={styles.content}>
        <Link to={urls.INSTAGRAM} className={styles.logo}>
          <img src={logoImage} alt="Glory Days Barber Co." />
        </Link>
        <Button to={urls.SCHEDULICITY}>
          Book Appointment
        </Button>
      </div>
      <GoogleMap />
    </Layout>
  )
}